import { Control } from 'ol/control';

export class ApplyControls extends Control {

  constructor(options?: {
    target?: string | HTMLElement | undefined,
    onApply?: () => void,
    onCancel?: () => void
  }) {

    const applyButton = document.createElement('button');
    applyButton.type = 'button';
    applyButton.id = 'map_apply_changes';
    applyButton.innerHTML = 'Zatwierdź';

    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.id = 'map_cancel_changes';
    cancelButton.innerHTML = 'Anuluj';

    const element = document.createElement('div');
    element.className = 'apply ol-unselectable ol-control';
    element.appendChild(cancelButton);
    element.appendChild(applyButton);

    super({
      element: element,
      target: options?.target
    });

    if (options?.onCancel) {
      cancelButton.addEventListener('click', options.onCancel.bind(this), false);
    }

    if (options?.onApply) {
      applyButton.addEventListener('click', options.onApply.bind(this), false);
    }
  }
}
